import { Collapsible } from '@highlight/ui'
import { twMerge } from 'tailwind-merge'
import { ActionReferenceTrigger } from './nested/trigger'
import { ActionReferenceContent } from './nested/content'

interface ActionReferenceProps {
  defaultOpen?: boolean
  className?: string
  children?: React.ReactNode
}

function ActionReference({ defaultOpen = false, className, children }: ActionReferenceProps) {
  return (
    <Collapsible defaultOpen={defaultOpen} className={twMerge('group/step mb-1 flex flex-col', className)}>
      {children}
    </Collapsible>
  )
}

ActionReference.Trigger = ActionReferenceTrigger
ActionReference.Content = ActionReferenceContent

export { ActionReference }
